/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { uniqueId } from 'lodash';
import { create } from 'zustand';
import { TestCase } from './elements/SemanticAuditorTestQuestions/SemanticAuditorTestQuestion.defs';

export type SemanticAuditorTestBuilderStore = SemanticAuditorTestBuilderStoreStates &
  SemanticAuditorTestBuilderStoreSetters &
  SemanticAuditorTestBuilderStoreUtilitySetters &
  SemanticAuditorTestBuilderStoreUtilityStates;

export interface SemanticAuditorTestBuilderStoreSetters {
  setName: (val: string) => void;
  setDescription: (val: string) => void;
  setQuestions: (val: Array<TestCase>) => void;
}

export interface SemanticAuditorTestBuilderStoreUtilitySetters {
  setClearForm: () => void;
  validateForm: () => Promise<boolean>;
}

export interface SemanticAuditorTestBuilderStoreUtilityStates {
  nameError: boolean;
  questionsErrors: Array<{
    question: boolean;
  }>;
}

export interface SemanticAuditorTestBuilderStoreStates {
  name: string;
  description: string;
  questions: Array<TestCase>;
}

export const initialState: SemanticAuditorTestBuilderStoreStates & SemanticAuditorTestBuilderStoreUtilityStates = {
  description: '',
  name: ``,
  nameError: false,
  questions: [
    {
      id: uniqueId(),
      question: '',
      referenceResponse: '',
    },
  ],
  questionsErrors: [],
};

export const useSemanticAuditorTestBuilderStore = create<SemanticAuditorTestBuilderStore>()((set) => ({
  ...initialState,
  setClearForm: (): void => set(initialState),
  setDescription: (val): void => set({ description: val }),
  setName: (val): void => set({ name: val }),
  setQuestions: (val): void => set({ questions: val }),
  validateForm: async (): Promise<boolean> => {
    let isValid = false;
    set((state) => {
      const nameError = !state.name?.trim().length;
      const questionsErrors = state.questions.map(({ question }) => ({
        question: !question?.trim().length,
      }));

      isValid = !(nameError || questionsErrors.some((e) => e.question));

      return { nameError, questionsErrors };
    });
    return isValid;
  },
}));
